import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import Tooltip from '@mui/material/Tooltip';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import _ from "lodash";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { getSecPermission, isEmptyDash, returnZero, strToDate, trimString, urlConstants } from "../../constant";
import { adminServices } from "../../services/adminServices";
import BoqDescriptionModal from "../common/boqDescriptionModal";
import { UserObj } from "../../services/localStarage";
import CustomSearchDropdown from "../common/customSearchDropdown";
import { projectServices } from "../../services/projectServices";
import { packageServices } from "../../services/packageServices";

const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

function DataanalysisReport() {
    const qcListing = {
        currentPage: 1,
        totalPages: 20,
      }
      
  const [opencreateentry, setOpenCreateEntry] = useState(false);
  const [isDescriptionModalOpen, setIsDescriptionModalOpen] = useState(false);
  const [modalDescription, setModalDescription] = useState("");
  const [modalDescriptionObj, setModalDescriptionObj] = useState({});
  const [isRequestModalOpen, setIsRequestModalOpen] = React.useState(false);
  
  const [selectedObj, setSelectedObj] = useState(null);
  const [selectedVendorObj, setSelectedVendorObj] = useState(null);
  const [selectedObjPO, setSelectedObjPO] = useState(null);
  
  const [secDelayAnalysisPermission, setSecDelayAnalysisPermission] = useState({
    "REVERSE_AUCTION_CREATION_DATE": permissionInit,
    "REVERSE_AUCTION_APPROVAL_DATE": permissionInit,
    "LOI_PUBLISH_DATE": permissionInit,
    "MFC_DATE": permissionInit,
    "FINAL_REMARKS": permissionInit,
    "DELAY_ANALYSIS_REPORT_LISTING": permissionInit,
  });
  
  useEffect(() => {
    let secDelayAnalysisPermissionInit = _.cloneDeep(secDelayAnalysisPermission);
    let obj = {};
    for (let key in secDelayAnalysisPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecDelayAnalysisPermission(obj);

  }, []);

  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };

  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };


  const dummyFun = () => {

  };

  const [isLoading, setIsLoading] = useState(false);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [listing, setListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    result: [],
  });
  const [selectedListItemArr, setSelectedListItemArr] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");
  
  const [inputPage, setInputPage] = useState(listing?.currentPage || 1);
  
    
      // const handleInputChange = (event) => {
      //   const value = event.target.value;
      //   if (value === '' || /^[0-9]+$/.test(value)) {
      //     setInputPage(value);
      //   }
      // };
    
      // const handleInputSubmit = (event) => {
      //   if (event.key === 'Enter') {
      //     const page = parseInt(inputPage, 10);
      //     if (!isNaN(page) && page > 0 && page <= qcListing?.totalPages) {
      //       onPaginationChange(event, page);
      //     } else {
      //       setInputPage(qcListing?.currentPage);
      //     }
      //   }
      // };

      const [columns, setColumns] = useState([]);
            
  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getListing(requestPayload, filterText, filterFormData, selectedObj?.selectedValue, selectedObjPO?.selectedValue);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
      // console.log("Debounce: ", searchTerm);

    }, 800),
    []
  );

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        // console.log(i, sortBy, sortOrder);
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
    // console.log(requestPayloadInit, columnsInit, index);
  }
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
    // console.log(requestPayloadInit, value);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
    // console.log(requestPayloadInit, value);
  }

  useEffect(() => {
    getListing(requestPayload, filterText, filterFormData, selectedObj?.selectedValue, selectedObjPO?.selectedValue);
  }, [requestPayload]);

  const getListing = (requestPayloadParam, filterTextParam, formData, projectId, packageId) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    if (!isEmptyDash(projectId)) {
      param += `&projectId=${projectId}`;      
    }
    if (!isEmptyDash(packageId)) {
      param += `&packageId=${packageId}`;      
    }
    
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    let promise = adminServices.getDelayAnalysisReport(param);
    promise.then((res) => {
      if (res.data.success === true) {
        res?.data?.data?.result?.map((ele, i) => {
          if (isEmptyDash(ele?.reverseAuctionDate)) {
            ele["isEditPencilViewReverseAuctionDate"] = true;
            ele["isEditCalenderReverseAuctionDate"] = false;
            ele["reverseAuctionDateDuplicate"] = ele?.reverseAuctionDate;
          }
          if (isEmptyDash(ele?.approvalDate)) {
            ele["isEditPencilViewApprovalDate"] = true;
            ele["isEditCalenderApprovalDate"] = false;
            ele["approvalDateDuplicate"] = ele?.approvalDate;
          }
          if (isEmptyDash(ele?.loiDate)) {
            ele["isEditPencilViewLoiDate"] = true;
            ele["isEditCalenderLoiDate"] = false;
            ele["loiDateDuplicate"] = ele?.loiDate;
          }
          if (isEmptyDash(ele?.mfcDate)) {
            ele["isEditPencilViewMfcDate"] = true;
            ele["isEditCalenderMfcDate"] = false;
            ele["mfcDateDuplicate"] = ele?.mfcDate;
          }
          if (isEmptyDash(ele?.remarks)) {
            ele["isEditPencilViewRemarks"] = true;
            ele["isEditCalenderRemarks"] = false;
            ele["remarksDuplicate"] = ele?.remarks;
          }
        });
        // console.log(res?.data?.data);
        
        setListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        // console.log(error);
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  
  const downloadReport = () => {
    setIsLoading(true);    
    let url = `${urlConstants.BASE_URI_DEV}/v1/internal/analysis-report/download`;
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${UserObj?.accessToken}`);
    myHeaders.append("Content-Type", "application/json");
    // let raw = JSON.stringify(bodyData);

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      // body: raw,
      redirect: "follow",
    };

    fetch(url, requestOptions)
      .then(response => response.blob())
      .then(blob => {
        const link = window.document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let fileName = "Delay_Analysis_Report.xlsx";
        
        link.download = fileName;
        window.document.body.appendChild(link);
        link.click();
        window.document.body.removeChild(link);
        
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };  

  const onSearchSelectChange = (param, objData) => {
    // console.log(param);      
    setSelectedObj(param);
    setSelectedVendorObj(objData);
    setSelectedObjPO({selectedLable: "", selectedValue: ""}); 
  }
    
  const onSearchSelectChangePO = (param) => {
    // console.log(param);      
    setSelectedObjPO(param);
  }

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= listing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(listing?.currentPage);
      }
    }
  };  

  const handleEditClick = (row, rowIndex, keyName, title, isDisablee) => {
    let obj = {
      title,
      text: row[keyName],
      isDisablee,
      rowData: row,
      rowIndex
    };
    // setModalDescription(row[keyName]);  
    setModalDescriptionObj(obj);
    setIsDescriptionModalOpen(true);
  };
  

  const onModalDescriptionChange = (value) => {
    setModalDescriptionObj((prevData) => ({...prevData, text: value}));
    setIsDescriptionModalOpen(true);
  };

  const editPencil = (param1, param2, rowIndex, value1, value2) => {
    let arr = _.cloneDeep(listing?.result);
    arr[rowIndex][param1] = value1;
    arr[rowIndex][param2] = value2;
    setListing((prevData) => ({...prevData, result: arr }));
  }
  
  const onCalenderChange = (value, rowIndex, param1) => {
    let arr = _.cloneDeep(listing?.result);
    arr[rowIndex][param1] = value;
    // arr[rowIndex][param2] = value2;
    setListing((prevData) => ({...prevData, result: arr }));
  }
  
  const cancelEdit = (param1, param2, param3, rowIndex, value1, value2, value3) => {    
    // let arr = _.cloneDeep(listing?.result);
    
    // console.log(param1, param2, param3, rowIndex, value1, value2, value3, arr);
    // arr[rowIndex][param1] = value1;
    // arr[rowIndex][param2] = value2;
    // arr[rowIndex][param3] = value3;
    // setListing((prevData) => ({...prevData, result: arr }));
        getListing(requestPayload, filterText, filterFormData, selectedObj?.selectedValue, selectedObjPO?.selectedValue);
  }

  const onModalSubmit = (param) => {
    console.log(modalDescriptionObj);
    submitData(modalDescriptionObj?.rowData, modalDescriptionObj?.rowIndex, "remarks", modalDescriptionObj?.text);    
  };

  const submitData = (data, rowIndex, param1, remarkText) => {
    // let arr = _.cloneDeep(listing?.result);
        
    let bodyData = {
      "packageId": data?.packageId,
      "rfqId": data?.rfqId,
      "purchaseOrderId": data?.purchaseOrderId,
    }; 

    if (param1 == "reverseAuctionDateDuplicate") {
      bodyData["reverseAuctionDate"] = data?.reverseAuctionDateDuplicate;
    }
    if (param1 == "approvalDateDuplicate") {
      bodyData["approvalDate"] = data?.approvalDateDuplicate;
    }
    if (param1 == "loiDateDuplicate") {
      bodyData["loiDate"] = data?.loiDateDuplicate;
    }
    if (param1 == "mfcDateDuplicate") {
      bodyData["mfcDate"] = data?.mfcDateDuplicate;
    }
    if (param1 == "remarks") {
      bodyData["remarks"] = remarkText;
    }
    
    console.log(bodyData, data, rowIndex, param1); 

      
    setIsLoading(true);
    let promise = adminServices.updateDelayAnalysisReport(bodyData);
    promise.then((res) => {
      if (res.data.success === true) {      
        setAlertComponent({ open: true, type: "success", message: `${res.data.message} ` });
        setIsDescriptionModalOpen(false);
        setModalDescriptionObj({});
        getListing(requestPayload, filterText, filterFormData, selectedObj?.selectedValue, selectedObjPO?.selectedValue);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
    .catch(function (error) {
      console.log(error);
      setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
    })
    .finally((param) => {
      setIsLoading(false);
    });
          
  }

  const applyFilter = (vendorId, poId) => {    
    getListing(requestPayload, filterText, filterFormData, selectedObj?.selectedValue, selectedObjPO?.selectedValue);
  };
  
  const clearData = (param) => {
    setSelectedObj({selectedLable: "", selectedValue: ""}); 
    setSelectedObjPO({selectedLable: "", selectedValue: ""});   
    getListing(requestPayloadInitials, "", filterFormData, "", "");
  }

  return (
  <>
  <div className="login-forms">
  <div className="text-centers">
  <div className="search_filter_outerse ms-auto">
              <div className="search_main">
                <h5>Delay Analysis Report</h5>
              </div>
              <div>
                  <button onClick={downloadReport} class="vendor_btn vendor_maine_contents">                
                  <FileDownloadIcon /> Download</button>
              </div>
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"
                      
                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              
              {/* <div className="bpdt_po_order_react">
                <div>
                  <button className="btn btn-outline-secondary sm">
                  <span>
                    <FilterAltOutlinedIcon/>
                  </span>
                  Filter
                </button>
                </div>
              </div> */}
            </div>

            <div className="d-flex " style={{marginBottom: "20px", alignItems:"end"}}>
              <div>
                <div className="required_react_vendor_block_dashboard">
                <label className="row_div_box_select_dashboard">Project ID</label>
                <div className="dashboard_site_select">
                    <CustomSearchDropdown 
                          // column={initialColumns}
                          listingArrName="projects"
                          onSearchSelectChange={onSearchSelectChange}
                          promiseRequest={projectServices?.getProjectListing}
                          // extraPromiseParam="poExists=true"
                          additionalData={{
                            lableKeyName1: "projectCode",
                            lableKeyName2: "",
                            valueKeyName: "_id",
                          }} 
                          // isDisable={(details?.assigneeId != UserObj?._id)}  
                          defaultValue={selectedObj}           
                      />  
                  </div>
                </div>
              </div>

              {/* <div>
                <div className="required_react_vendor_block_dashboard" style={{marginLeft: "10px"}}>
                <label className="row_div_box_select_dashboard">Package ID</label>
                <div className="dashboard_site_select">
                  
                    <CustomSearchDropdown 
                          // column={initialColumns}
                          listingArrName="packages"
                          onSearchSelectChange={onSearchSelectChangePO}
                          promiseRequest={packageServices.getPackageListing}
                          extraPromiseParam=""
                          isDependency={true}
                          dependencyData={{
                            method: "GET",
                            keyName: "projectCode",
                            keyValue: selectedVendorObj?.projectCode
                          }}
                          additionalData={{
                            lableKeyName1: "packageName",
                            lableKeyName2: "",
                            valueKeyName: "_id",
                          }} 
                          // isDisable={(details?.assigneeId != UserObj?._id)}  
                          defaultValue={selectedObjPO}           
                      />  
                  </div>
                </div>
              </div> */}

              <div className="invoicing_dashboard_btns">
                <button type="button" class="btn btn-success save_next_btns" onClick={() => applyFilter(selectedObj?.selectedValue, selectedObjPO?.selectedValue)}>
                  Apply
                </button>
                <button type="button" class="btn clear_btn_status_block_lists" style={{marginLeft: "10px"}} onClick={clearData}>
                  Clear
                </button>
              </div>
              
            </div>

          <div className="listing_main listing_main_dragdropcontext_body comparsion_bidding_table ">
                <table className="">

                    <thead className="">
                      <tr className="">
                        <th className="sectiondataAnalysis_data" colSpan={4}>
                          
                        </th>
                        
                        <th className="sectiondataAnalysis sectiondataAnalysis_data" colSpan={2}>
                        Avt. TAT : <span className="daysReact">{returnZero(listing?.averageTats?.avgLastOfferTat)} days</span>
                        </th>
                        <th className="sectiondataAnalysis sectiondataAnalysis_data" colSpan={2}>
                        Avt. TAT : <span className="daysReact">{returnZero(listing?.averageTats?.avgReverseAuctionTat)} days</span>
                        </th>
                        <th className="sectiondataAnalysis sectiondataAnalysis_data" colSpan={2}>
                        Avt. TAT : <span className="daysReact">{returnZero(listing?.averageTats?.avgLoiTat)} days</span>
                        </th>
                        <th className="sectiondataAnalysis sectiondataAnalysis_data" colSpan={2}>
                        Avt. TAT : <span className="daysReact">{returnZero(listing?.averageTats?.avgPoReleaseTat)} days</span>
                        </th>
                        <th className="sectiondataAnalysis sectiondataAnalysis_data" colSpan={3}>
                        Avt. TAT : <span className="daysReact">{returnZero(listing?.averageTats?.avgGateEntryMfcTat)} days</span>
                        </th>
                        <th className="sectiondataAnalysis sectiondataAnalysis_data" colSpan={1}>
                        {/* Avt. TAT : <span className="daysReact">7 days</span> */}
                        </th>
                        <th></th>
                      </tr>
                      <tr>
                        <th><input type="checkbox"/></th>
                        <th>Package Code</th>
                        <th>Package Name</th>
                        <th  className="sectiondataAnalysis_data">Package Creaction<br/> Date</th>
                        <th className="">RFQ Creaction/<br/>Publish Date</th>
                        <th className="sectiondataAnalysis_data">Date of last Offer <br/> Received in Round 1</th>
                        <th>Technical Evaluation<br/> Closure date</th>
                        <th className="sectiondataAnalysis_data">Reverse Auction <br/>Creation Date</th>
                        <th>Reverse Auction<br/> Approval Date</th>
                        <th className="sectiondataAnalysis_data">Letter of Intent<br/> Publish Date</th>
                        <th>PR Confirmation <br/>/Entry Date</th>
                        <th className="sectiondataAnalysis_data">PO Release Date<br/> from SAP</th>
                        <th>MFC Date</th>
                        <th className="">Delivery Date <br/> (As per PO)</th>
                        <th className="sectiondataAnalysis_data">Delivery Date<br/> (As per Actual)</th>
                        <th className="sectiondataAnalysis_data">Delay in Delivery</th>
                        <th>Final Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listing?.result.length < 1 && <>
                        <tr>
                          <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                        </tr>
                      </>}
                      
                      {listing?.result?.map((row, rowIndex) => (
                        <tr>
                          <td><input type="checkbox"/></td>
                          <td className="block_solar">
                            {/* {row?.packageCode} */}
                          <Tooltip title={row?.packageCode}> {trimString(row?.packageCode, 20)}</Tooltip>
                          </td>
                          <td> 
                            <span onClick={() => handleEditClick(row, rowIndex, "packageName", "Package Name", true)}>
                             {/* {trimString(row?.packageName, 30)} */}
                             <Tooltip title={row?.packageName}> {trimString(row?.packageName, 20)}</Tooltip>
                            </span> 
                            </td>
                          <td className="sectiondataAnalysis_data">
                            {/* {strToDate(row?.packageCreationDate)} */}
                            <Tooltip title={strToDate(row?.packageCreationDate)}> {trimString(strToDate(row?.packageCreationDate), 20)}</Tooltip>
                            </td>
                          <td>
                            {/* {strToDate(row?.rfqCreationDate)} */}
                            <Tooltip title={strToDate(row?.rfqCreationDate)}> {trimString(strToDate(row?.rfqCreationDate), 20)}</Tooltip>
                            </td>
                          <td className="sectiondataAnalysis_data">
                            {/* {strToDate(row?.lastBidSubmissionDate)} */}
                            <Tooltip title={strToDate(row?.lastBidSubmissionDate)}> {trimString(strToDate(row?.lastBidSubmissionDate), 20)}</Tooltip>
                            </td>
                          <td>
                            {/* {strToDate(row?.technicalEvalCompletedAt)} */}
                            <Tooltip title={strToDate(row?.technicalEvalCompletedAt)}> {trimString(strToDate(row?.technicalEvalCompletedAt), 20)}</Tooltip>
                            </td>

                          <td className="sectiondataAnalysis_data">
                            {(!isEmptyDash(row?.reverseAuctionDate)) && <span onClick={() => editPencil("isEditPencilViewReverseAuctionDate", "isEditCalenderReverseAuctionDate", rowIndex, false, true)}>{strToDate(row?.reverseAuctionDate)}</span>}

                            <div className="inputsection_React">
                              {(row?.isEditPencilViewReverseAuctionDate == true && secDelayAnalysisPermission?.REVERSE_AUCTION_CREATION_DATE?.read == true) && <EditOutlinedIcon onClick={() => editPencil("isEditPencilViewReverseAuctionDate", "isEditCalenderReverseAuctionDate", rowIndex, false, true)} />}

                              {(row?.isEditCalenderReverseAuctionDate == true) && <><input type="date" class="form-control form-ha" fdprocessedid="i4xin7" value={row?.reverseAuctionDateDuplicate} onChange={(e) => onCalenderChange(e.target.value, rowIndex, "reverseAuctionDateDuplicate" )} />

                              <button className="btn btn-success save_next_btns" onClick={() => submitData(row, rowIndex, "reverseAuctionDateDuplicate")}>Add</button>

                              <button className="btn clear_btn_status_block_lists" onClick={() => cancelEdit("isEditPencilViewReverseAuctionDate", "isEditCalenderReverseAuctionDate", "reverseAuctionDate", rowIndex, true, false, null)}>Cancel</button></>}
                            </div>
                          </td>
                          <td>
                            
                              {(!isEmptyDash(row?.approvalDate)) && <span onClick={() => editPencil("isEditPencilViewApprovalDate", "isEditCalenderApprovalDate", rowIndex, false, true)}>{strToDate(row?.approvalDate)}</span>}
                            <div className="inputsection_React">                              
                              {(row?.isEditPencilViewApprovalDate == true && secDelayAnalysisPermission?.REVERSE_AUCTION_APPROVAL_DATE?.read == true) && <EditOutlinedIcon onClick={() => editPencil("isEditPencilViewApprovalDate", "isEditCalenderApprovalDate", rowIndex, false, true)} />}

                              {(row?.isEditCalenderApprovalDate == true) && <><input type="date" class="form-control form-ha" fdprocessedid="i4xin7" value={row?.approvalDateDuplicate} onChange={(e) => onCalenderChange(e.target.value, rowIndex, "approvalDateDuplicate" )} />

                              <button className="btn btn-success save_next_btns" onClick={() => submitData(row, rowIndex, "approvalDateDuplicate")}>Add</button>

                              <button className="btn clear_btn_status_block_lists" onClick={() => cancelEdit("isEditPencilViewApprovalDate", "isEditCalenderApprovalDate", "approvalDate", rowIndex, true, false, null)}>Cancel</button></>}
                            </div>
                          </td>
                          <td className="sectiondataAnalysis_data">
                              {(!isEmptyDash(row?.loiDate)) && <span onClick={() => editPencil("isEditPencilViewLoiDate", "isEditCalenderLoiDate", rowIndex, false, true)}>{strToDate(row?.loiDate)}</span>}
                            <div className="inputsection_React">
                                {(row?.isEditPencilViewLoiDate == true  && secDelayAnalysisPermission?.LOI_PUBLISH_DATE?.read == true) && <EditOutlinedIcon onClick={() => editPencil("isEditPencilViewLoiDate", "isEditCalenderLoiDate", rowIndex, false, true)} />}
                                {(row?.isEditCalenderLoiDate == true) && <><input type="date" class="form-control form-ha" fdprocessedid="i4xin7" value={row?.loiDateDuplicate} onChange={(e) => onCalenderChange(e.target.value, rowIndex, "loiDateDuplicate" )} />
                                <button className="btn btn-success save_next_btns" onClick={() => submitData(row, rowIndex, "loiDateDuplicate")}>Add</button>
                                <button className="btn clear_btn_status_block_lists" onClick={() => cancelEdit("isEditPencilViewLoiDate", "isEditCalenderLoiDate", "loiDate", rowIndex, true, false, null)}>Cancel</button></>}
                            </div>
                          </td>
                          <td>
                            {/* {strToDate(row?.prEntryDate)} */}
                            <Tooltip title={strToDate(row?.prEntryDate)}> {trimString(strToDate(row?.prEntryDate), 20)}</Tooltip>
                            </td>
                             <td className="sectiondataAnalysis_data">
                           {/* {strToDate(row?.sapReleaseDate)} */}
                            <Tooltip title={strToDate(row?.sapReleaseDate)}> {trimString(strToDate(row?.sapReleaseDate), 20)}</Tooltip>
                           </td>                         
                          <td>
                          {(!isEmptyDash(row?.mfcDate)) && <span onClick={() => editPencil("isEditPencilViewMfcDate", "isEditCalenderMfcDate", rowIndex, false, true)}>
                            {/* {strToDate(row?.mfcDate)} */}
                            <Tooltip title={strToDate(row?.mfcDate)}> {trimString(strToDate(row?.mfcDate), 20)}</Tooltip>
                            </span>}
                            <div className="inputsection_React">
                                {(row?.isEditPencilViewMfcDate == true  && secDelayAnalysisPermission?.MFC_DATE?.read == true) && <EditOutlinedIcon onClick={() => editPencil("isEditPencilViewMfcDate", "isEditCalenderMfcDate", rowIndex, false, true)} />}

                                {(row?.isEditCalenderMfcDate == true) && <><input type="date" class="form-control form-ha" fdprocessedid="i4xin7" value={row?.mfcDate} onChange={(e) => onCalenderChange(e.target.value, rowIndex, "mfcDateDuplicate" )} />

                                <button className="btn btn-success save_next_btns" onClick={() => submitData(row, rowIndex, "mfcDateDuplicate")}>Add</button>

                                <button className="btn clear_btn_status_block_lists" onClick={() => cancelEdit("isEditPencilViewMfcDate", "isEditCalenderMfcDate", "mfcDate", rowIndex, true, false, null)}>Cancel</button></>}
                            </div>
                          </td>
                          <td className="">
                            {/* {strToDate(row?.deliveryDate)} */}
                            <Tooltip title={strToDate(row?.deliveryDate)}> {trimString(strToDate(row?.deliveryDate), 20)}</Tooltip>
                            </td>
                          <td className="sectiondataAnalysis_data">
                            {/* {strToDate(row?.gateEntryDate)} */}
                            <Tooltip title={strToDate(row?.gateEntryDate)}> {trimString(strToDate(row?.gateEntryDate), 20)}</Tooltip>
                            </td>
                          <td className="sectiondataAnalysis_data">
                            {/* {row?.delayInDelivery} */}
                            <Tooltip title={row?.delayInDelivery}> {trimString(row?.delayInDelivery, 20)}</Tooltip>
                            </td>
                          <td>
                              <div className="holdReactSection">
                                {(!isEmptyDash(row?.remarks)) && <span onClick={() => handleEditClick(row, rowIndex, "remarks", "Remarks", true)}>
                                  {/* {trimString(row?.remarks, 30)} */}
                                  <Tooltip title={row?.remarks}> {trimString(row?.remarks, 20)}</Tooltip>
                                  </span> }
                                  {(isEmptyDash(row?.remarks)) &&<RemoveRedEyeOutlinedIcon onClick={() => handleEditClick(row, rowIndex, "remarks", "Remarks", false)} />}
                              </div>
                          </td> 
                        </tr>
                      ))}
                    </tbody>
                </table>
            </div>
          
            {listing?.result.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(listing?.pageSize) * Number(listing?.currentPage - 1) + 1} to ${Number(listing?.pageSize) * Number(listing?.currentPage - 1) + Number(listing?.result.length)} of ${listing?.totalItems}`}
                </span>
              </div>

              <Stack spacing={2}>
                <Pagination
                  count={listing?.totalPages}
                  page={listing?.currentPage}
                  onChange={(event, page) => {
                    setInputPage(page);
                    onPaginationChange(event, page);
                  }}
                  renderItem={(item) => {
                    if (item.page === listing?.currentPage) {
                      return (
                        <input
                          className="form-control"
                          type="text"
                          value={inputPage}
                          onChange={handleInputChange}
                          onKeyDown={handleInputSubmit}
                          style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                        />
                      );
                    }
                    return (
                      <PaginationItem
                        className="pagination_react_listings"
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                      />
                    );
                  }}
                />
              </Stack>
            </div>
          </>}
  </div>
  </div>
  
        {/* Description Modal  */}
        <BoqDescriptionModal
            isModalOpen={isDescriptionModalOpen}
            setIsModalOpen={setIsDescriptionModalOpen}
            handleModalSubmit={onModalSubmit}
            setModalDescription={onModalDescriptionChange}
            modalDescription={modalDescriptionObj?.text}
            title={modalDescriptionObj?.title}
            isDisablee={modalDescriptionObj?.isDisablee}
          />

    <AlertComponent
          alertComponent={alertComponent}
          handleClose={handleCloseAlert}
        />

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => 99999999,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
  </>
  )
}

export default DataanalysisReport